import React from "react";
import { Breadcrumb } from "../components/shared/Breadcrumb";
import { ButtonLink } from "../components/shared/Button";
import { BuildingJourney } from "../components/sections/BuildingJourney";
import { PageMeta } from "../components/shared/PageMeta";
export function OurProcess() {
  return <>
      <PageMeta title="Our Building Process | Oceanside Living Perth" description="How building with Oceanside Living works, from your first conversation and pre-construction agreement to construction and handover." data-id="element-746" data-mp="1c7qspt13phih" />
      <div className="mx-auto max-w-site px-5 pb-16 pt-10 md:px-10 md:pb-28 md:pt-14" data-id="element-747" data-mp="1l6cavn2nuuiq">
        <Breadcrumb items={[{
        label: "Home",
        to: "/"
      }, {
        label: "Our process"
      }]} data-id="element-748" data-mp="1q7rt77dgemxf" />
        <div className="mt-6 grid gap-8 lg:grid-cols-12" data-id="element-749" data-mp="1v50evhxt993f">
          <div className="lg:col-span-7" data-id="element-750" data-mp="3ryv5s26wmbkm">
            <h1 className="text-[38px] font-semibold leading-[1.08] tracking-tight md:text-[60px]" data-id="element-751" data-mp="3rzwsj3xa8mi6">Our building process</h1>
            <p className="mt-5 text-[17px] leading-relaxed text-slate md:text-lg" data-id="element-752" data-mp="uelr9a1ois3">
              Building a home is a big decision. Whether you choose one of our designs and make it your own, or take the custom
              design route, we guide you through ten clear stages so you know what’s happening, what’s required and what’s coming next.
            </p>
          </div>
          <aside className="border-l-2 border-ocean bg-white p-6 lg:col-span-5 lg:self-end" data-id="element-753" data-mp="2ribs2txbf06y">
            <h2 className="text-lg font-semibold" data-id="element-754" data-mp="3o5zwya8d8w8k">About the pre-construction agreement</h2>
            <p className="mt-2 text-[16px] leading-relaxed text-slate" data-id="element-755" data-mp="3j99h9o0h42no">
              Design, site investigation and costing work is set out in a pre-construction agreement. Its scope and cost are agreed
              with you in writing before that work begins.
            </p>
          </aside>
        </div>
        <div className="mt-14" data-id="element-756" data-mp="23s7lcdotykbq">
          <BuildingJourney detailed data-id="element-757" data-mp="23p3a4wcy6obk" />
        </div>
        <div className="mt-14 flex flex-col gap-4 sm:flex-row" data-id="element-758" data-mp="1yrbim3g7t47w">
          <ButtonLink to="/contact" data-id="element-759" data-mp="209ii2divkzky">Book a consultation</ButtonLink>
          <ButtonLink to="/#faqs" variant="secondary" data-id="element-760" data-mp="20abgmr7okis0">Read common questions</ButtonLink>
        </div>
      </div>
    </>;
}